export default __webpack_public_path__ + "static/media/PicsArt_03-03-07.20.28.33dec2a3.jpg";